// =============================
// Email: info@xx.com
// www.xx.com/templates
// =============================

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://bridgev2qaapi.smartcircle.com', // Change this to the address of your backend API if different from frontend address
  authServerUrl: 'https://bridgev2qaapi.smartcircle.com' as string | null, // Auth/IdentityServer URL for separate-container deployment
  loginUrl: '/login',
  hjPortalUrl:'https://portalqa.herbjoyent.com/webforms-green/',

  // Salesforce Embedded Messaging (Web Chat) — TEST / SANDBOX org.
  // Fill in the placeholders below with your Salesforce sandbox deployment details, then set enabled: true.
  // IMPORTANT: the browser calls scrt2URL directly, so the origin serving this app
  // (e.g. http://localhost:4200, https://bridgeqa.smartcircle.com) MUST be added in Salesforce
  // Setup -> CORS (Allowed Origins List) AND on the Embedded Service deployment's trusted URLs,
  // otherwise the request is blocked with a CORS error.
  // Sandbox: smartcircle--full.sandbox.my.salesforce.com (Full sandbox)
  salesforceChat: {
    enabled: false,                                                              // set true once orgId + deployment path are filled in
    orgId: '00D000000000000',                                                    // TODO: sandbox 15/18-char Org Id (differs from prod)
    eswConfigName: 'Web_Chat_External',                                          // Embedded Service deployment developer name
    baseUrl: 'https://smartcircle--full.sandbox.my.site.com/ESWWebChatExternalXXXXXXXXXX', // TODO: replace XXXXXXXXXX with the sandbox deployment path (Experience Site URL, not my.salesforce.com)
    scrt2URL: 'https://smartcircle--full.sandbox.my.salesforce-scrt.com',        // SCRT2 (messaging) endpoint — derived from the sandbox domain
    language: 'en_US'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
